import useSWR from 'swr';
import { getUserPsuedoId } from 'lib/firebase/ga_analytics';
import { AuthState } from 'hooks/useFirebaseAuth';
import { useEffect } from 'react';

interface UserPseudoIdLoaderProps {
  authState: AuthState;
  setIsValidating: (value: boolean) => void;
  setUserPseudoId: (value?: string | null) => void;
}

const UserPseudoIdLoader = ({
  authState,
  setIsValidating,
  setUserPseudoId
}: UserPseudoIdLoaderProps) => {
  const { data: userPseudoId, isValidating } = useSWR(
    authState !== AuthState.PENDING ? `user-pseudo-id` : null,
    getUserPsuedoId,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );

  useEffect(() => {
    setIsValidating(isValidating);
    setUserPseudoId(userPseudoId);
  }, [isValidating, setIsValidating, userPseudoId, setUserPseudoId]);

  return null;
};

export default UserPseudoIdLoader;
